import { seedEntityCache } from 'utils/entities';
import { useEffect } from 'react';
import { useQueryClient } from 'react-query';

/**
 * Prime the `['entity', …]` cache from a data_points sidecar, so the breadcrumb,
 * header and sidebar asking for the same ids don't each issue a request.
 */
const useSeedEntityCache = (entities, dataSource) => {
    const queryClient = useQueryClient();
    useEffect(() => {
        if (entities) seedEntityCache(queryClient, entities, dataSource);
    }, [entities, dataSource, queryClient]);
};

export default useSeedEntityCache;
